<div class="lesson-navigation"></div>

<div class="lesson-container">
	<lb-lesson-card-v2
		[lesson]="lesson()"
		[lessonNumber]="lessonNumber()"
		userView="instructor"
		displayedUser="learner"
		[clickable]="false"
		[showActions]="false"
		[showLocked]="isLocked()"
	></lb-lesson-card-v2>

	@if (!state.showDetails()) {
		<lb-lesson-detail-unavailable userView="instructor" />
	} @else {
		<md-content-box class="actions">
			@if (!isReadOnly()) {
				@if (typeDropdownReady()) {
					<md-drop-down
						label="Lesson Type"
						placeholder="Lesson Type"
						[dense]="true"
						[options]="lessonTypeOptions()"
						[value]="lesson().lessonTypeID"
						[disabled]="lessonTypeDisabled()"
						(change)="updateLessonType($event)"
					>
					</md-drop-down>
				}
			}
			<span class="spacer"></span>
			@if (!isReadOnly()) {
				@if (canJoin()) {
					<a href="https://teams.microsoft.com/?web=1" target="_blank" md-button-brand data-analytics="lesson-join" (click)="onJoinLesson()">Join</a>
				}

				@if (canReschedule() || (lesson() && canTakeAttendanceForLesson() && !isMultiAttendance())) {
					<md-button-group>
						@if (canReschedule()) {
							<md-button-toggle value="reschedule" data-analytics="lesson-reschedule" (click)="reschedule()" [canBeChecked]="false"
								>Reschedule</md-button-toggle
							>
						}
						<!-- Multi-attendance lessons have no single "Absent": absences are per member on the roster below. -->
						@if (lesson() && canTakeAttendanceForLesson() && !isMultiAttendance()) {
							<md-button-toggle value="attendance" data-analytics="lesson-mark-absent" (click)="markAbsent()" [canBeChecked]="false"
								>Mark Absent</md-button-toggle
							>
						}
					</md-button-group>
				}
			}

			<!-- Draft replaces Complete outright until the lesson may be completed, rather than sitting
			     next to a dead button. It saves details only: no attendance, no invoice, no validation.
			     The tooltip carries the "completable from" time, since Complete isn't here to say it. -->
			@if (showSaveDraft()) {
				<span class="actions__draft" [md-tooltip]="draftTooltip()" [md-tooltip-disabled]="!draftTooltip()" md-tooltip-position="top-end">
					<button md-button data-analytics="lesson-draft-save" (click)="saveDraft()" [disabled]="!canSaveDraft()">
						{{ isSaving() ? 'Saving...' : 'Save as Draft' }}
					</button>
				</span>
			} @else {
				<!-- The tooltip lives on this wrapper, not the button: a disabled button dispatches no mouse events. -->
				<span class="actions__complete" [md-tooltip]="completeTooltip()" [md-tooltip-disabled]="!completeTooltip()" md-tooltip-position="top-end">
					@if (state.isFinalSemester()) {
						<button
							md-button-brand
							data-analytics="final-review-save"
							(click)="saveFinalSemester()"
							[disabled]="!canComplete() || !canSave() || isSaving() || isReadOnly()"
						>
							{{ saveButtonText() }}
						</button>
					} @else {
						<button
							md-button-brand
							data-analytics="lesson-review-save"
							(click)="saveLesson()"
							[disabled]="!canComplete() || !canSave() || isSaving() || isReadOnly() || !attendanceSelectionMade()"
						>
							{{ saveButtonText() }}
						</button>
					}
				</span>
			}
		</md-content-box>

		<div class="lesson-content" [class.lesson-content--full]="summaryOnly()">
			@if (!summaryOnly()) {
				<div class="content-side">
					<!-- Rendered for every multi-attendance lesson, even with an empty roster — the
					     component's own empty state ("No members are on this lesson's roster") is
					     more diagnosable than a silently missing section. -->
					@if (isMultiAttendance()) {
						<md-content-box>
							<!-- Bound to attendanceDisabled, not fieldsDisabled: the detail fields open before the
							     lesson starts so drafts can be pre-populated, but attendance does not. -->
							<lb-lesson-roster-attendance
								[members]="rosterMembers()"
								[readonly]="hasTakenAttendance()"
								[disabled]="attendanceDisabled()"
								(presentChange)="rosterPresentIDs.set($event)"
								(noAttendeesChange)="rosterNoAttendees.set($event)"
							/>
						</md-content-box>
					}

					@if (state.activeLearnerSurveys().length > 0 || state.activeInstructorSurveys().length > 0) {
						<lb-lesson-detail-survey />
					}

					@if (isFinalSemester()) {
						<lb-lesson-detail-project-final />
					} @else if (isGradedInstructional()) {
						<lb-lesson-detail-daily-grades />
						<lb-lesson-detail-objectives />
						<lb-lesson-detail-project-progress />
						<lb-lesson-detail-homework />
					}
				</div>
			}

			<div class="content-side">
				<lb-lesson-detail-summary />
			</div>
		</div>
	}
</div>
